export function CommentIcon ({ fill = 'black' }) {
  return (
    <svg
      width='20px'
      height='19px'
      viewBox='0 0 20 19'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Comments</title>
      <g
        id='IGAO'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='03.-Medication---Create-Issues'
          transform='translate(-946.000000, -515.000000)'
          fill={fill}
        >
          <g
            id='Group-4'
            transform='translate(946.349921, 515.944316)'
          >
            <path
              d='M9.41227695,0.0038595713 C3.93211583,0.057154403 3.41060513e-13,2.57870439 3.41060513e-13,8.5556843 L0.0433388489,9.60564533 L0.0700401552,10.0600892 L0.102430928,10.4535857 C0.132456892,10.7603569 0.170895787,11.0195866 0.223963625,11.2711382 L0.295064748,11.5718657 C0.308217859,11.6222232 0.322055584,11.6729113 0.336627651,11.724249 C0.537561195,12.4321421 0.868579117,13.1116453 1.3921225,13.8750325 L1.59759786,14.1654541 C1.70388533,14.2815853 1.72745123,14.5118464 1.67236343,15.0068329 L1.57292126,15.7653105 C1.43216256,16.9469646 1.54386384,17.4549331 2.30981794,17.8084544 C2.82790555,18.0475745 3.35110231,18.0407607 3.9076195,17.8466959 L4.06785951,17.7875337 L4.22170994,17.7222599 L4.49417368,17.5883629 L4.89026576,17.377646 C5.63239572,16.9775582 5.98918647,16.8636114 6.39905445,16.9436379 C14.457872,18.5228798 18.9658509,14.6948779 18.9658509,8.5556843 C18.9658509,6.92984196 18.539209,5.08793358 17.4791792,3.51630298 C15.9758361,1.28740332 13.4464437,0.00296470006 9.77517066,4.79616347e-14 L9.41227695,0.0038595713 Z M9.43296307,1.30367008 C12.8739312,1.2276054 15.1018923,2.31652142 16.4014149,4.24323093 C17.2958517,5.56934847 17.6658509,7.16671777 17.6658509,8.5556843 C17.6658509,13.886058 13.895257,17.0879011 6.64861396,15.6678166 C5.91060157,15.5237199 5.35803487,15.6709762 4.49568969,16.1159049 L3.90217385,16.4307368 L3.73591259,16.5137251 L3.60383731,16.5723832 L3.47957151,16.6191883 C3.21899047,16.7100563 3.03727538,16.7124228 2.8545987,16.6281095 L2.84695957,16.6207585 L2.83424551,16.5817986 C2.83249818,16.5723734 2.83096561,16.5614035 2.82969119,16.5487705 L2.82548952,16.4520699 L2.82956589,16.3097789 L2.84400276,16.1162204 L2.87088263,15.8657173 L2.91693209,15.5199928 C3.08767223,14.3204746 3.07377432,13.819537 2.58504026,13.3255698 C2.08961815,12.6329943 1.76853056,12.0080187 1.58722368,11.3692707 C1.50374488,11.0751731 1.44883618,10.7984855 1.40871587,10.4404977 L1.37762724,10.1114385 L1.35185326,9.72874515 L1.29945809,8.52914774 C1.3,3.44721847 4.56881471,1.35102395 9.43296307,1.30367008 Z'
              id='Oval'
              fillRule='nonzero'
            />
            <ellipse
              id='Oval'
              cx='9.50007941'
              cy='8.8556843'
              rx='1'
              ry='1'
            />
            <ellipse
              id='Oval'
              cx='5.50007941'
              cy='8.8556843'
              rx='1'
              ry='1'
            />
            <ellipse
              id='Oval'
              cx='13.5000794'
              cy='8.8556843'
              rx='1'
              ry='1'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
